import React, { FC } from 'react'
import { observer } from 'mobx-react'
import WaterfallTemplate from './WaterfallTemplate'
import { menuMobx, restaurantConfig } from 'restaurant'
import './index.scss'

interface IProps {
}

const ProductTemplate: FC<IProps> = () => {
  const { getProductsForSortCategory } = menuMobx
  const products = getProductsForSortCategory.filter(item => menuMobx.isOpenSoldout ? item.saleCnt !== 0 : true)
  return (
    <div className='product-template'>
      <WaterfallTemplate products={products} selectCategoryNo={menuMobx.selectCategoryNo} />
    </div>
  )
}

export default observer(ProductTemplate)
